export const getPrimaryUrl = (link) => link?.links?.[0]?.url || link?.url;
